import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const buyers = [{
  name: 'Carolina L.',
  location: 'Buenos Aires'
}, {
  name: 'María V.',
  location: 'Mendoza'
}, {
  name: 'Sofía M.',
  location: 'Rosario'
}, {
  name: 'Daniela L.',
  location: 'Córdoba'
}, {
  name: 'Florencia B.',
  location: 'La Plata'
}];
export function FloatingNotification() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(buyers[0]);
  useEffect(() => {
    const initial = window.setTimeout(() => setVisible(true), 5000);
    const cycle = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setBuyer(buyers[Math.floor(Math.random() * buyers.length)]);
        setVisible(true);
      }, 850);
    }, 30000);
    return () => {
      window.clearTimeout(initial);
      window.clearInterval(cycle);
    };
  }, []);
  return <AnimatePresence data-id="element-77" data-mp="2fzap8xs3d089">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 35,
      x: -12
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 15,
      scale: 0.96
    }} transition={{
      type: 'spring',
      stiffness: 380,
      damping: 26
    }} className="fixed bottom-4 left-4 z-50 max-w-sm md:bottom-8 md:left-8" data-id="element-78" data-mp="20v2bgf2suiwq">
          <div className="flex items-start gap-3 rounded-2xl border border-brand-gold/40 bg-white p-4 shadow-xl" data-id="element-79" data-mp="1mw2nl9n4281m">
            <div className="mt-0.5 rounded-full bg-brand-purple/10 p-2" data-id="element-80" data-mp="1hz2gcveiyz8x">
              <CheckCircle2Icon className="h-5 w-5 text-brand-purple" data-id="element-81" data-mp="1d4y3xwmhpz0g" />
            </div>
            <div data-id="element-82" data-mp="1887p1cmf99gm">
              <p className="mb-1 text-xs text-brand-muted" data-id="element-83" data-mp="187pq288dkh50">🔔 Compra verificada • hace unos minutos</p>
              <p className="text-sm font-medium text-brand-text" data-id="element-84" data-mp="136a1w7awhuie">
                <strong data-id="element-85" data-mp="z5gd7bpmwbog">{buyer.name}</strong> de {buyer.location} compró
              </p>
              <p className="text-sm font-bold text-brand-purple" data-id="element-86" data-mp="u8pyarpkfm4m">Mega Pack Maestro de Gemoterapia™</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}